module.exports = __webpack_public_path__ + "static/media/IntroChevron.8f0eecf9.png";